 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","baronbet-themeWrapLive":"baronbet-themeWrapLive","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betfirst-themeWrapLive":"betfirst-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bethappy-themeWrapLive":"bethappy-themeWrapLive","betmen-themeWrapLive":"betmen-themeWrapLive","betnest-themeWrapLive":"betnest-themeWrapLive","betsportnamibia-themeWrapLive":"betsportnamibia-themeWrapLive","blackjackfun-themeWrapLive":"blackjackfun-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","boulparyaj-themeWrapLive":"boulparyaj-themeWrapLive","bugbet-themeWrapLive":"bugbet-themeWrapLive","carrus-themeWrapLive":"carrus-themeWrapLive","liveComponent":"liveComponent","coinhero-themeWrapLive":"coinhero-themeWrapLive","cryptocasino-themeWrapLive":"cryptocasino-themeWrapLive","damagi-dark-themeWrapLive":"damagi-dark-themeWrapLive","damagi-light-themeWrapLive":"damagi-light-themeWrapLive","demo-themeWrapLive":"demo-themeWrapLive","drewmanbetting-themeWrapLive":"drewmanbetting-themeWrapLive","expo-themeWrapLive":"expo-themeWrapLive","formulabih-themeWrapLive":"formulabih-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","grandslotbet-themeWrapLive":"grandslotbet-themeWrapLive","greenlotto-themeWrapLive":"greenlotto-themeWrapLive","happySpins-themeWrapLive":"happySpins-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","heycasino-themeWrapLive":"heycasino-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","lyracasino-themeWrapLive":"lyracasino-themeWrapLive","maxbet-themeWrapLive":"maxbet-themeWrapLive","moicasino-themeWrapLive":"moicasino-themeWrapLive","olimp-themeWrapLive":"olimp-themeWrapLive","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrapLive":"powerbet-themeWrapLive","pozeparyaj-themeWrapLive":"pozeparyaj-themeWrapLive","prontobet-themeWrapLive":"prontobet-themeWrapLive","prvafirma-themeWrapLive":"prvafirma-themeWrapLive","pulsebet-themeWrapLive":"pulsebet-themeWrapLive","quickslots-themeWrapLive":"quickslots-themeWrapLive","reisbet-themeWrapLive":"reisbet-themeWrapLive","satibet-themeWrapLive":"satibet-themeWrapLive","sima-themeWrapLive":"sima-themeWrapLive","slotparadise-themeWrapLive":"slotparadise-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","stanleybet-themeWrapLive":"stanleybet-themeWrapLive","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","yaacasino-themeWrapLive":"yaacasino-themeWrapLive"}[chunkId]||chunkId) + "." + {"avalon-themeWrapLive":"2db6bbc0","baronbet-themeWrapLive":"60879e7e","bb-themeWrapLive":"c75213bf","betcoinsportsxmb-themeWrapLive":"da9ff010","betfirst-themeWrapLive":"137a8e72","betflip-themeWrapLive":"e62ff1cf","bethappy-themeWrapLive":"0cafb78d","betmen-themeWrapLive":"ac237785","betnest-themeWrapLive":"ffca4ce1","betsportnamibia-themeWrapLive":"6d1b246b","blackjackfun-themeWrapLive":"f1c25c32","bmk-themeWrapLive":"28580bae","boulparyaj-themeWrapLive":"bb4ef414","bugbet-themeWrapLive":"8b862f89","carrus-themeWrapLive":"1ecbdb13","chunk-4464ae99":"91aa17ba","chunk-03b9aa56":"e08871f4","chunk-7b2248dc":"12748791","liveComponent":"11d9ed2a","coinhero-themeWrapLive":"0eaeec9c","cryptocasino-themeWrapLive":"2609407e","damagi-dark-themeWrapLive":"25e64bcd","damagi-light-themeWrapLive":"3c68138c","demo-themeWrapLive":"ba28684a","drewmanbetting-themeWrapLive":"2a7c6fba","expo-themeWrapLive":"73b1bb45","formulabih-themeWrapLive":"16994fd0","futurebet-themeWrapLive":"d496a00b","grandslotbet-themeWrapLive":"54e94b48","greenlotto-themeWrapLive":"5e6483a3","happySpins-themeWrapLive":"600291c8","hemingwaynew-themeWrapLive":"d5d99c84","heycasino-themeWrapLive":"23b6a557","isiparyaj-themeWrapLive":"e2ea2ba2","lutrijabihlive-themeWrap":"013bd446","lyracasino-themeWrapLive":"628ce502","maxbet-themeWrapLive":"14d4cd66","moicasino-themeWrapLive":"35de855c","olimp-themeWrapLive":"bb6f7aff","playbetr-themeWrapLive":"302da57a","powerbet-themeWrapLive":"137fa99d","pozeparyaj-themeWrapLive":"2bb84293","prontobet-themeWrapLive":"9403dbb0","prvafirma-themeWrapLive":"efdc9330","pulsebet-themeWrapLive":"ce954df0","quickslots-themeWrapLive":"7015cbd5","reisbet-themeWrapLive":"abf68efa","satibet-themeWrapLive":"500aa3fe","sima-themeWrapLive":"84c78ba5","slotparadise-themeWrapLive":"a28ff08f","sportnaloterija-themeWrapLive":"9a69261a","stanleybet-themeWrapLive":"97aba426","themeWrapLive":"2311549a","themeWrapLiveLight":"95cea4b7","topbet-themeWrap":"8aa17234","victory-themeWrapLive":"a4021d9c","wettnet-themeWrapLive":"286c59a1","yaacasino-themeWrapLive":"90f613cc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"avalon-themeWrapLive":1,"baronbet-themeWrapLive":1,"bb-themeWrapLive":1,"betcoinsportsxmb-themeWrapLive":1,"betfirst-themeWrapLive":1,"betflip-themeWrapLive":1,"bethappy-themeWrapLive":1,"betmen-themeWrapLive":1,"betnest-themeWrapLive":1,"betsportnamibia-themeWrapLive":1,"blackjackfun-themeWrapLive":1,"bmk-themeWrapLive":1,"boulparyaj-themeWrapLive":1,"bugbet-themeWrapLive":1,"carrus-themeWrapLive":1,"liveComponent":1,"coinhero-themeWrapLive":1,"cryptocasino-themeWrapLive":1,"damagi-dark-themeWrapLive":1,"damagi-light-themeWrapLive":1,"demo-themeWrapLive":1,"drewmanbetting-themeWrapLive":1,"expo-themeWrapLive":1,"formulabih-themeWrapLive":1,"futurebet-themeWrapLive":1,"grandslotbet-themeWrapLive":1,"greenlotto-themeWrapLive":1,"happySpins-themeWrapLive":1,"hemingwaynew-themeWrapLive":1,"heycasino-themeWrapLive":1,"isiparyaj-themeWrapLive":1,"lutrijabihlive-themeWrap":1,"lyracasino-themeWrapLive":1,"maxbet-themeWrapLive":1,"moicasino-themeWrapLive":1,"olimp-themeWrapLive":1,"playbetr-themeWrapLive":1,"powerbet-themeWrapLive":1,"pozeparyaj-themeWrapLive":1,"prontobet-themeWrapLive":1,"prvafirma-themeWrapLive":1,"pulsebet-themeWrapLive":1,"quickslots-themeWrapLive":1,"reisbet-themeWrapLive":1,"satibet-themeWrapLive":1,"sima-themeWrapLive":1,"slotparadise-themeWrapLive":1,"sportnaloterija-themeWrapLive":1,"stanleybet-themeWrapLive":1,"themeWrapLive":1,"themeWrapLiveLight":1,"topbet-themeWrap":1,"victory-themeWrapLive":1,"wettnet-themeWrapLive":1,"yaacasino-themeWrapLive":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"avalon-themeWrapLive":"avalon-themeWrapLive","baronbet-themeWrapLive":"baronbet-themeWrapLive","bb-themeWrapLive":"bb-themeWrapLive","betcoinsportsxmb-themeWrapLive":"betcoinsportsxmb-themeWrapLive","betfirst-themeWrapLive":"betfirst-themeWrapLive","betflip-themeWrapLive":"betflip-themeWrapLive","bethappy-themeWrapLive":"bethappy-themeWrapLive","betmen-themeWrapLive":"betmen-themeWrapLive","betnest-themeWrapLive":"betnest-themeWrapLive","betsportnamibia-themeWrapLive":"betsportnamibia-themeWrapLive","blackjackfun-themeWrapLive":"blackjackfun-themeWrapLive","bmk-themeWrapLive":"bmk-themeWrapLive","boulparyaj-themeWrapLive":"boulparyaj-themeWrapLive","bugbet-themeWrapLive":"bugbet-themeWrapLive","carrus-themeWrapLive":"carrus-themeWrapLive","liveComponent":"liveComponent","coinhero-themeWrapLive":"coinhero-themeWrapLive","cryptocasino-themeWrapLive":"cryptocasino-themeWrapLive","damagi-dark-themeWrapLive":"damagi-dark-themeWrapLive","damagi-light-themeWrapLive":"damagi-light-themeWrapLive","demo-themeWrapLive":"demo-themeWrapLive","drewmanbetting-themeWrapLive":"drewmanbetting-themeWrapLive","expo-themeWrapLive":"expo-themeWrapLive","formulabih-themeWrapLive":"formulabih-themeWrapLive","futurebet-themeWrapLive":"futurebet-themeWrapLive","grandslotbet-themeWrapLive":"grandslotbet-themeWrapLive","greenlotto-themeWrapLive":"greenlotto-themeWrapLive","happySpins-themeWrapLive":"happySpins-themeWrapLive","hemingwaynew-themeWrapLive":"hemingwaynew-themeWrapLive","heycasino-themeWrapLive":"heycasino-themeWrapLive","isiparyaj-themeWrapLive":"isiparyaj-themeWrapLive","lutrijabihlive-themeWrap":"lutrijabihlive-themeWrap","lyracasino-themeWrapLive":"lyracasino-themeWrapLive","maxbet-themeWrapLive":"maxbet-themeWrapLive","moicasino-themeWrapLive":"moicasino-themeWrapLive","olimp-themeWrapLive":"olimp-themeWrapLive","playbetr-themeWrapLive":"playbetr-themeWrapLive","powerbet-themeWrapLive":"powerbet-themeWrapLive","pozeparyaj-themeWrapLive":"pozeparyaj-themeWrapLive","prontobet-themeWrapLive":"prontobet-themeWrapLive","prvafirma-themeWrapLive":"prvafirma-themeWrapLive","pulsebet-themeWrapLive":"pulsebet-themeWrapLive","quickslots-themeWrapLive":"quickslots-themeWrapLive","reisbet-themeWrapLive":"reisbet-themeWrapLive","satibet-themeWrapLive":"satibet-themeWrapLive","sima-themeWrapLive":"sima-themeWrapLive","slotparadise-themeWrapLive":"slotparadise-themeWrapLive","sportnaloterija-themeWrapLive":"sportnaloterija-themeWrapLive","stanleybet-themeWrapLive":"stanleybet-themeWrapLive","themeWrapLive":"themeWrapLive","themeWrapLiveLight":"themeWrapLiveLight","topbet-themeWrap":"topbet-themeWrap","victory-themeWrapLive":"victory-themeWrapLive","wettnet-themeWrapLive":"wettnet-themeWrapLive","yaacasino-themeWrapLive":"yaacasino-themeWrapLive"}[chunkId]||chunkId) + "." + {"avalon-themeWrapLive":"505ceec6","baronbet-themeWrapLive":"b349c06e","bb-themeWrapLive":"ee667af4","betcoinsportsxmb-themeWrapLive":"11b57d7c","betfirst-themeWrapLive":"4542affc","betflip-themeWrapLive":"5cbf525c","bethappy-themeWrapLive":"953565c5","betmen-themeWrapLive":"df824560","betnest-themeWrapLive":"f36d956f","betsportnamibia-themeWrapLive":"920e9c4d","blackjackfun-themeWrapLive":"8a4393ff","bmk-themeWrapLive":"9f196a91","boulparyaj-themeWrapLive":"09a32446","bugbet-themeWrapLive":"8ff9bb85","carrus-themeWrapLive":"ddc2f0a3","chunk-4464ae99":"31d6cfe0","chunk-03b9aa56":"31d6cfe0","chunk-7b2248dc":"31d6cfe0","liveComponent":"8c1d4266","coinhero-themeWrapLive":"404f7f64","cryptocasino-themeWrapLive":"1d8207f8","damagi-dark-themeWrapLive":"5859b236","damagi-light-themeWrapLive":"8ff9bb85","demo-themeWrapLive":"69934122","drewmanbetting-themeWrapLive":"a52aca8b","expo-themeWrapLive":"69934122","formulabih-themeWrapLive":"9e7f5342","futurebet-themeWrapLive":"3607d0a3","grandslotbet-themeWrapLive":"40d3ec64","greenlotto-themeWrapLive":"a1988fa7","happySpins-themeWrapLive":"301a0aed","hemingwaynew-themeWrapLive":"9f196a91","heycasino-themeWrapLive":"ccae6291","isiparyaj-themeWrapLive":"735c3c58","lutrijabihlive-themeWrap":"e44bec4b","lyracasino-themeWrapLive":"0f073535","maxbet-themeWrapLive":"fafbeb5e","moicasino-themeWrapLive":"0d336f57","olimp-themeWrapLive":"1093f66b","playbetr-themeWrapLive":"9a4cdec8","powerbet-themeWrapLive":"cea586bc","pozeparyaj-themeWrapLive":"a2801a85","prontobet-themeWrapLive":"56cd98e3","prvafirma-themeWrapLive":"d1de4f3c","pulsebet-themeWrapLive":"fbecc0a1","quickslots-themeWrapLive":"fb1cf4c7","reisbet-themeWrapLive":"706a9f1f","satibet-themeWrapLive":"0935b1a2","sima-themeWrapLive":"4f88c475","slotparadise-themeWrapLive":"e960aee1","sportnaloterija-themeWrapLive":"673871d6","stanleybet-themeWrapLive":"4c8de133","themeWrapLive":"09a32446","themeWrapLiveLight":"3ade6b9f","topbet-themeWrap":"480e7d06","victory-themeWrapLive":"42cd6448","wettnet-themeWrapLive":"a157d196","yaacasino-themeWrapLive":"be764f6d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"vendor-utilities"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
